module.exports = __webpack_public_path__ + "img/fullscreen.e4e2d34e.svg";